/**
 * PaymentCancelPage - Page d'annulation de paiement
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  
  // V35.63 — Retour contextuel : priorité au `payment_return_path` stocké
  // par la page qui a initié l'achat. Fallback : dashboard par rôle.
  const getRedirectPath = () => {
    try {
      const stored = sessionStorage.getItem('payment_return_path');
      if (stored && stored.startsWith('/')) {
        sessionStorage.removeItem('payment_return_path');
        return stored;
      }
    } catch {}

    const userRole = localStorage.getItem('userRole');
    switch (userRole) {
      case 'super_admin':
        return '/admin/super-dashboard';
      case 'cooper':
        return '/cooper/dashboard';
      case 'expert':
        return '/expert/dashboard';
      default:
        return '/member/dashboard';
    }
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl p-8 text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-amber-100 flex items-center justify-center">
          <XCircle className="w-10 h-10 text-amber-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Paiement annulé
        </h1>
        
        <p className="text-gray-500 mb-6">
          Votre paiement a été annulé. Aucun montant n'a été débité de votre compte.
        </p>
        
        <div className="space-y-3">
          <Button 
            onClick={() => navigate(-1)}
            className="w-full bg-gradient-to-r from-amber-500 to-orange-600 text-white hover:opacity-90"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Réessayer le paiement
          </Button>
          
          <Button 
            variant="outline"
            onClick={() => navigate(getRedirectPath())}
            className="w-full"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour à mon espace
          </Button>
        </div>
        
        <p className="text-xs text-gray-400 mt-6">
          Besoin d'aide ? Contactez notre support à support@coppam.fr
        </p>
      </div>
    </div>
  );
}
